export interface UtcDateRange {
  fromUtc: string;
  toUtc: string;
}

export function getLocalDayUtcRange(now = new Date()): UtcDateRange {
  const localStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const localEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  const result: UtcDateRange = {
    fromUtc: localStart.toISOString(),
    toUtc: localEnd.toISOString(),
  };
  return result;
}

export function localDateInputToUtcRange(fromDate: string, toDate: string): Partial<UtcDateRange> {
  const result: Partial<UtcDateRange> = {};
  if (fromDate) {
    result.fromUtc = new Date(`${fromDate}T00:00:00`).toISOString();
  }

  if (toDate) {
    const inclusiveEnd = new Date(`${toDate}T00:00:00`);
    inclusiveEnd.setDate(inclusiveEnd.getDate() + 1);
    result.toUtc = inclusiveEnd.toISOString();
  }

  return result;
}
